import { IInspectionAdapter } from './IInspectionAdapter';
import { ApiResponse } from '../../types/api';
import {
  Inspection,
  Verification,
  Closure,
  ClosureEvent,
  CreateInspectionDto,
  CreateVerificationDto,
  InspectionFilter,
  VerificationFilter,
} from '../../types/inspection';
import { ApiClient } from '../apiClient';

export class LaravelInspectionAdapter implements IInspectionAdapter {
  async getInspections(filter?: InspectionFilter): Promise<ApiResponse<Inspection[]>> {
    const params = new URLSearchParams(filter as any).toString();
    return ApiClient.get<Inspection[]>(`/api/v1/inspections?${params}`);
  }

  async getInspectionById(id: string): Promise<ApiResponse<Inspection>> {
    return ApiClient.get<Inspection>(`/api/v1/inspections/${id}`);
  }

  async createInspection(data: CreateInspectionDto): Promise<ApiResponse<Inspection>> {
    return ApiClient.post<Inspection>('/api/v1/inspections', data);
  }

  async getVerifications(filter?: VerificationFilter): Promise<ApiResponse<Verification[]>> {
    const params = new URLSearchParams(filter as any).toString();
    return ApiClient.get<Verification[]>(`/api/v1/verifications?${params}`);
  }

  async createVerification(data: CreateVerificationDto): Promise<ApiResponse<Verification>> {
    return ApiClient.post<Verification>('/api/v1/verifications', data);
  }

  async closeComplaint(complaintId: string, data: { verification_id: string; satisfaction_rating: number }): Promise<ApiResponse<Closure>> {
    return ApiClient.post<Closure>(`/api/v1/complaints/${complaintId}/close`, data);
  }

  async getClosureHistory(complaintId: string): Promise<ApiResponse<ClosureEvent[]>> {
    return ApiClient.get<ClosureEvent[]>(`/api/v1/complaints/${complaintId}/closure-history`);
  }
}
